export interface IconProps {
  name: Icons;
  height?: number;
  width?: number;
  fill?: string;
}

export enum Icons {
  Error = 'error',
  Success = 'success',
  Warning = 'warning',
  Cancel = 'cancel',
  Info = 'info',
  ActivityIndicator = 'activity-indicator',
  ArrowUp = 'arrow-up',
  ArrowDown = 'arrow-down',
  Hamburger = 'hamburger',
  Chat = 'chat',
  ArrowRightBG = 'arrow-right-with-bg',
  CheckMark = 'check-mark',
  Facebook = 'facebook',
  Twitter = 'twitter',
  LinkedIn = 'linkedin',
  Instagram = 'instagram',
  ArrowRight = 'arrowRight',
  Search = 'search',
  DashboardHamburger = 'dashboard-hamburger',
  Profile = 'profile',
  Logout = 'logout',
  Notification = 'notification',
  Dashboard = 'dashboard',
  Assets = 'assets',
  Beneficiary = 'beneficiary',
  Executors = 'executors',
  Guardians = 'guardians',
  Trustees = 'trustee',
  Message = 'message',
  Will = 'will',
  Call = 'call',
  QuickTips = 'quick-tip',
  Bank = 'bank',
  Stocks = 'stocks',
  Pension = 'pension',
  Insurance = 'insurance',
  MoreMenu = 'more-menu',
  ArrowDownCircle = 'arrow-down-cirlce',
  Filter = 'filter',
  Export = 'export',
  Print = 'print',
  ArrowUpCircle = 'arrow-up-cirlce',
  SelectDropdown = 'select-dropdown',
  Edit = 'edit',
  Close = 'close',
  AddCircle = 'add-circle',
  Delete = 'delete',
  Required = 'required',
  NationalID = 'national-id',
  Passport = 'passport',
  DriverLicense = 'driver-license',
  VotersCard = 'voters-card',
  BVN = 'bvn',
  AddCircleOutline = 'add-circle-outline',
  UncheckBox = 'uncheckbox',
  CheckedBox = 'checkedbox',
  EditProfile = 'edit-rofile',
  Add = 'add',
  VectorRight = 'vector-right',
  Minus = 'minus',
  Addition = 'addition',
  ArrowLeft = 'arrow-left',
  ArrowLeftCircle = 'arrow-left-circle',
  Users = 'users',
  TwoUsers = 'two-users',
  SingleUser = 'single-user',
  MultipleUser = 'multiple-user',
  Customer = 'customer',
  Prospect = 'prospect',
  iWillCompleted = 'iWillCompleted',
  iWillPending = 'iWillPending',
  ExportArrowUp = 'export-arrow-up',
  CircleUp = 'circle-up',
  CircleDown = 'circle-down',
  Upload = 'upload',
  Note = 'note',
  CircleSuccess = 'circle-success'
}
